export const enum PhoneCountryCode {
  Portugal = '+351',
  Spain = '+34',
}
